import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { toast } from 'react-toastify';
import { editConsultantById } from '../../utils/api';
import './IntermediaryPasswordModal.css';

Modal.setAppElement('#root');

export default function IntermediaryPasswordModal({ isOpen, consultantId, onClose }) {
    const [password, setPassword] = useState('');
    const [passwordConfirm, setPasswordConfirm] = useState('');
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (!isOpen) {
            setPassword('');
            setPasswordConfirm('');
        }
    }, [isOpen]);

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (password.length < 6) {
            toast.info('A nova senha deve ter pelo menos 6 caracteres.');
            return;
        }

        if (password !== passwordConfirm) {
            toast.info('A nova senha e a confirmação não coincidem.');
            return;
        }

        setSaving(true);
        const toastId = toast.loading('Alterando senha...');

        try {
            await editConsultantById(consultantId, { password });
            toast.update(toastId, {
                render: 'Senha alterada com sucesso!',
                type: 'success',
                isLoading: false,
                autoClose: 2500,
            });
            onClose();
        } catch (error) {
            toast.update(toastId, {
                render: 'Não foi possível alterar a senha.',
                type: 'error',
                isLoading: false,
                autoClose: 3000,
            });
        } finally {
            setSaving(false);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel="Alterar senha do intermediário"
            className="intermediary-password-modal"
            overlayClassName="intermediary-password-overlay"
            shouldCloseOnOverlayClick
        >
            <div className="intermediary-password-header">
                <div>
                    <span>Segurança</span>
                    <h2>Alterar senha</h2>
                </div>
                <button type="button" onClick={onClose} aria-label="Fechar alteração de senha">X</button>
            </div>

            <form className="intermediary-password-form" onSubmit={handleSubmit}>
                <label>
                    <span>Nova senha</span>
                    <input
                        type="password"
                        value={password}
                        onChange={(event) => setPassword(event.target.value)}
                        autoComplete="new-password"
                        placeholder="Mínimo de 6 caracteres"
                        required
                    />
                </label>

                <label>
                    <span>Confirmar nova senha</span>
                    <input
                        type="password"
                        value={passwordConfirm}
                        onChange={(event) => setPasswordConfirm(event.target.value)}
                        autoComplete="new-password"
                        placeholder="Digite a nova senha novamente"
                        required
                    />
                </label>

                <div className="intermediary-password-footer">
                    <button type="button" className="intermediary-password-cancel" onClick={onClose}>
                        Cancelar
                    </button>
                    <button type="submit" className="intermediary-password-save" disabled={saving}>
                        {saving ? 'Alterando...' : 'Alterar senha'}
                    </button>
                </div>
            </form>
        </Modal>
    );
}
